<template>
  <main id="conteudo">
    <article id="doar" class="home__donate">
      <div class="container" id="donation-wrap">
        <Payment />
      </div>
    </article>

    <article class="home__intro">
      <div class="container">
        <h2>
          Sua contribuição é muito importante
        </h2>

        <p>
          Com a Resolução do Tribunal Superior Eleitoral –
          <a href="http://www.tse.jus.br/legislacao-tse/res/2017/RES235532017.html" target="_blank">TSE nº 23.553/2017</a>,
          o modelo de arrecadação para as campanhas políticas mudou e pode ser
          realizado por meio de doações financeiras pessoais, com toda fiscalização
          do TSE. Fazendo aqui a sua doação, você estará contribuindo com as nossas
          ideias e propostas independentes para mudar o Brasil. Toda contribuição,
          por menor que seja, é importante para nós.
        </p>

        <section id="campaign-progress" class="campaign-progress">
          <p>
            <span class="currency">R$</span>
            <strong class="amount" v-inview="isAmountOnViewport">
              <template v-if="totalAmount">
                <span>
                  <animated-number
                    :value="amountInView ? totalAmount : 0"
                    :formatValue="FormatFixedBRL"
                    :duration="1000"/>
                </span>
              </template>
              <template v-else>0</template>
            </strong>
          </p>
          <p class="campaign-progress-amount">
            {{ totalDonors | thousandsSeparator }}
            <template v-if="totalDonors > 1">
              doações realizadas
            </template>
            <template v-else>
              doação realizada
            </template>
          </p>

          <div role="progressbar" aria-valuemin="0"
            :aria-valuenow="totalAmount" :aria-valuemax="expected"
            v-if="donationSources.length > 1">

            <div v-for="(source, i) in donationSources" :key="i"
              :style="progressBarStyle(source)"
              :title="`${porcentage(source.total_donated)}% via ${source.name}`"
              v-if="source.total_donated">
              {{ porcentage(source.total_donated) }}
            </div>
          </div>
          <progress :value="totalAmount" :max="expected" v-else>
            <div role="progressbar" :aria-valuenow="totalAmount" :aria-valuemax="expected">
              <div :style="{width: `${porcentage(totalAmount)}%`}">
                {{ porcentage(totalAmount) }}
              </div>
            </div>
          </progress>

          <p class="campaign-progress-porcentage">
            {{ porcentage() }}% da meta de R$ {{ expected | formatBRL }}
          </p>

          <div v-if="donationSources.length > 1" class="donations-sources">
            <p>Sendo:</p>
            <ul>
              <li v-for="(source, i) in donationSources" :key="i">
                <strong class="donations-sources__amount">
                  R$ {{ source.total_donated | formatBRL }}
                </strong> /
                <em class="donations-sources__donations">
                  {{ source.people_donated }}
                </em>
                <template v-if="source.people_donated > 1">
                  doações via
                </template>
                <template v-else>
                  doação via
                </template>
                <details v-if="source.cnpj || source.social_name">
                  <summary>{{ source.name }}</summary>
                  <p v-if="source.cnpj">
                    <em>
                      <abbr title="Cadastro Nacional de Pessoa Jurídica">CNPJ</abbr>:
                    </em>
                    {{ source.cnpj | formatCNPJ }}
                  </p>
                  <p v-if="source.social_name">
                    <em>
                      Razão social:
                    </em>
                    {{ source.social_name }}
                  </p>
                </details>
                <template v-else>
                  {{ source.name }}
                </template>
              </li>
            </ul>
          </div>
          <p>
            <a href="#home__donors" class="campaign-progress__link"
              v-scroll-to="'#home__donors'">
              Veja quem doou
            </a>
          </p>

          <p class="contact-pdt contact-pdt-email">
            <a href="https://www.cirogomes.com.br/#contato" target="_blank">Junte-se a nós</a>
          </p>

        </section>
      </div>
    </article>

    <article id="home__knowMore" class="home__knowMore">
      <div class="container" id="donation-wrap">
        <h2>
          Conheça
        </h2>

        <p>
          Eu quero caminhar por todo nosso pais, em todos os territórios, para
          apresentar as nossas ideias, recolher suas sugestões e suas críticas, para
          que possamos reconstruir no Brasil a confiança de que essa grande nação
          poderá voltar a ser justa, para que nosso povo saia do sofrimento em que
          se encontra e reencontre a felicidade e a realização pelo trabalho.
        </p>

        <p>
          Você sabe que campanha política, mesmo as mais modestas, custam dinheiro.
          E pela primeira vez na história do Brasil, a lei permite agora que pela
          internet, com toda a fiscalização do Tribunal Superior Eleitoral, possa
          recolher contribuições. Essa é uma novidade importante porque ela permite
          que você pulverize ao máximo as contribuições e diminua, ou até extinga, a
          influência do poder econômico.
        </p>

        <p>
          Com as ideias que eu tenho, você sabe, de aumentar imposto para rico e
          diminuir imposto pra pobre e pra classe média, de reforçar o Brasil quem
          produz e que trabalha, enfrentando os interesses internacionais que
          cobiçam as nossas riquezas, eu vou enfrentar uma parada muito dura e
          desigual. Por isso hoje eu venho não sem um certo... um pouquinho
          encabulado, mas falando de coração pra coração, hoje eu estou vindo com
          base nesta novidade legal pedir a você que entre no nosso site e faça uma
          contribuição, qualquer valor é muito importante, você estará ajudando a
          construir uma proposta independente para mudar o Brasil e transformar
          nosso país naquilo que ele tem que ser: uma nação justa e generosa com a
          sua gente.
        </p>
      </div>
    </article>

    <article id="home__goals" class="home__goals">
      <div class="container" id="donation-wrap">
        <h2>
          Metas
        </h2>

        <h3>R$ 300 mil</h3>
        <h4>
          Ciro na Internet
        </h4>

        <p>
          Ciro Gomes tem as melhores propostas para mudar o Brasil, mas muita gente ainda
          não conhece. Com a sua doação, vamos fortalecer e difundir as ideias de Ciro
          nas redes sociais. Levar a informação para as pessoas que ainda não o conhecem,
          espalhar a mensagem do Ciro por todo o país através da internet! Vamos juntos!
        </p>

      </div>
    </article>

    <Faq />

    <article id="home__donors" class="home__donors">
      <div class="container" id="donation-wrap">
        <h2>
          Doadores
        </h2>

        <p>
          Conheça as pessoas que acreditam que o Brasil tem tudo para virar esse
          jogo e doaram para nossa campanha:
        </p>

        <div class="nav-link-donations-wrap">
          <a class="nav-link-donations" href="/doadores">
            ver dados completos
          </a>
        </div>
      </div>
    </article>

  </main>
</template>

<script>
// @ is an alias to /src
// eslint-disable-next-line
import AnimatedNumber from 'animated-number-vue';
import Payment from '@/components/Payment.vue';
import Faq from '@/components/Faq.vue';

export default {
  data() {
    return {
      amountInView: false,
    };
  },
  name: 'home',
  components: {
    Payment,
    AnimatedNumber,
    Faq,
  },
  mounted() {
    const candidateId = (window.location.host === 'doe.portalcirogomes.com.br' || window.location.host === 'doe.cirogomes.com.br') ? 236 : 202;
    this.$store.dispatch('GET_CANDIDATE_INFO', candidateId);
    this.$store.dispatch('UPDATE_DONATIONS_SUMMARY', candidateId);
  },
  computed: {
    candidate() {
      return this.$store.state.candidate;
    },
    donationSources() {
      let opacity = 0;
      return this.$store.state.donationSources
        .map((x) => {
          const y = x;
          y.opacity = opacity;
          opacity += 0.25;
          return y;
        });
    },
    totalAmount() {
      return this.donationSources.length
        ? this.donationSources.reduce(
          (accumulator, currentValue) =>
            accumulator + currentValue.total_donated
          , 0,
        )
        : (this.candidate.total_donated || 0);
    },
    totalDonors() {
      return this.donationSources.length
        ? this.donationSources.reduce(
          (accumulator, currentValue) =>
            accumulator + Number.parseInt(currentValue.people_donated || 0, 10)
          , 0,
        )
        : Number.parseInt(this.candidate.people_donated || 0, 10);
    },
    donors() {
      return this.$store.state.donors;
    },
    donationsRecentCount() {
      return this.$store.state.donationsRecentCount;
    },
    donationsRecent() {
      return this.$store.state.donationsRecent;
    },
    hasMoreDonations() {
      return this.$store.state.hasMoreDonations;
    },
    expected() {
      return (this.candidate || {}).raising_goal || 0;
    },
  },
  methods: {
    porcentage(amount = this.totalAmount) {
      return Math.round((parseFloat(amount) * 100) / Math.max(this.totalAmount, this.expected));
    },
    progressBarStyle(source) {
      return {
        backgroundImage: `linear-gradient(rgba(0, 0, 0, ${source.opacity}), rgba(0, 0, 0, ${source.opacity}))`,
        width: `${this.porcentage(source.total_donated)}%`,
      };
    },
    FormatFixedBRL(amount) {
      let formated = `${(amount / 100).toFixed(2)}`;

      formated = formated
        .substring(0, formated.length - 2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        .replace(/\.+$/, '');
      return formated;
    },
    isAmountOnViewport(evt, el) {
      const rect = el.getBoundingClientRect();

      this.$data.amountInView = (
        rect.width > 0 &&
        rect.height > 0 &&
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      );

      return this.$data.amountInView;
    },
  },
  directives: {
    inview: {
      inserted: (el, binding) => {
        const f = (evt) => {
          if (binding.value(evt, el)) {
            window.removeEventListener('scroll', f);
          }
        };
        window.addEventListener('scroll', f);
        f();
      },
    },
  },
};
</script>
